












import Vue from 'vue';

export default Vue.extend({
  props: ['imgSrc'],
  mounted() {
    document.addEventListener('keyup', (event) => {
      if (event.keyCode === 27) {
        this.closeImg();
      }
    });
  },
  methods: {
    toggleZoom() {
      this.toggleZoomData = !this.toggleZoomData;
    },
    closeImg() {
      this.toggleZoomData = false;
      this.loadImage = false;
      this.$emit('loadImageClose');
    },
  },
  data() {
    return {
      loadImage: true,
      toggleZoomData: false,
    };
  },
});
